import React from 'react';
import { Link } from 'react-router-dom';

import { jobs } from '../data/mockData';

const JobGrid = ({ onApplyJob }) => {
  return (
    <div className='flex-1'>
      <div className='text-center py-8 mb-8'>
        <h3 className='text-lg font-medium text-red-500 mb-2'>
          Jobs Coming Soon
        </h3>
        <p className='text-red-400'>
          Job opportunities and internships will be available here.
        </p>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4'>
        {jobs.map(job => (
          <div
            key={job.id}
            className='bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md hover:scale-105 transition-all duration-300'
          >
            {/* Job Header */}
            <div className='p-4 border-b border-gray-100'>
              <div className='flex items-center justify-between mb-3'>
                <span
                  className={`px-2 py-1 text-xs font-medium rounded-full ${
                    job.status === 'Urgent'
                      ? 'bg-yellow-100 text-yellow-800'
                      : 'bg-green-100 text-green-800'
                  }`}
                >
                  {job.status}
                </span>
                <span className='text-xs text-gray-500'>{job.timePosted}</span>
              </div>

              <h3 className='font-bold text-gray-900 text-sm mb-2'>
                {job.title}
              </h3>
              <p className='text-xs text-gray-600 leading-relaxed'>
                {job.description}
              </p>
            </div>

            {/* Job Content */}
            <div className='p-3'>
              {/* Skill Tags */}
              <div className='mb-3'>
                <div className='flex flex-wrap gap-1'>
                  {job.skills.slice(0, 3).map((skill, index) => (
                    <span
                      key={index}
                      className='px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full font-medium'
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              {/* Recruiter Info */}
              <div className='flex items-center mb-3'>
                <img
                  src={job.recruiter.avatar}
                  alt={job.recruiter.name}
                  className='w-6 h-6 rounded-full mr-2'
                />
                <div>
                  <p className='text-xs font-medium text-gray-900'>
                    {job.recruiter.name}
                  </p>
                  <p className='text-xs text-gray-500'>
                    {job.applicants} applicants
                  </p>
                </div>
              </div>

              {/* Due Date and Apply Button */}
              <div className='flex items-center justify-between'>
                <span className='text-xs text-gray-600'>
                  Due: {job.dueDate}
                </span>
                <button
                  onClick={() => onApplyJob && onApplyJob(job.id)}
                  className='bg-purple-500 text-white px-3 py-1 rounded-md text-xs font-medium hover:bg-purple-600 transition-colors duration-200'
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JobGrid;
